export const APP_CONFIG = {
  // Polling interval for docket updates (5 seconds)
  POLLING_INTERVAL: 5000,

  // Docket service base URL from environment variable
  DOCKET_SERVICE_URI:
    import.meta.env.VITE_DOCKET_SERVICE_URI ||
    'https://test-in.oolio.dev/api/kds',

  // Time window for client-side docket filtering (in hours)
  // Only show orders from last X hours in ORB display
  DOCKET_FILTER_HOURS: 2,

  // Auto-clear timeout for Ready orders (in seconds)
  // Ready orders will be marked as COMPLETED after this timeout
  AUTO_CLEAR_TIMEOUT_SECONDS: 15 * 60,

  // Pagination interval for ORB display (in milliseconds)
  // Time between automatic page transitions
  PAGINATION_INTERVAL: 10000,
  API_URL: import.meta.env.VITE_API_URL || 'http://localhost:4000/graphql',
  SUBSCRIPTION_URL:
    import.meta.env.VITE_SUBSCRIPTION_URL || 'ws://localhost:4000/graphql',
  // App version is injected at build time via VITE_ORB_APP_VERSION; fallback if missing (Only for web)
  VITE_ORB_APP_VERSION: import.meta.env.VITE_ORB_APP_VERSION || 'unknown',
} as const;
